import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import IPLPTemplateCreate from './IPLPTemplateCreate';

interface Props extends BaseModalProps {
	onCreate: () => void;
}

const IPLPTemplateCreateModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.IPLPTemplateCreateModal.title'>
			<IPLPTemplateCreate onCreate={props.onCreate} />
		</BaseModal>
	);
};

export default IPLPTemplateCreateModal;
